import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "person-panel-list__count" }
const _hoisted_2 = { class: "person-panel-list__count-number" }
const _hoisted_3 = { class: "person-panel-list__group-name" }
const _hoisted_4 = {
  key: 1,
  class: "person-panel-list__partial"
}
const _hoisted_5 = {
  key: 2,
  class: "person-panel-list__end"
}

import {
	computed,
	onBeforeUnmount,
	onMounted,
	ref, watch
} from "vue";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {clientPageStore} from "@/store/client-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsBlockPanelList',
  props: {
    searchText: {}
  },
  emits: ["on-get-partial"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const clientStore = clientPageStore()
const $personPanelList = ref<HTMLDivElement | null>(null)
const isScrollBtnVisible = ref(false)

const isLoadingAll = computed(() => clientStore.clientContactsLoading);
const isLoadingPartial = computed(() => clientStore.clientContactsPartialLoading);
const canLoadNext = computed(() => clientStore.canLoadNextContacts);
const clients = computed(() => clientStore.clientContacts);

const scrollListTop = () => {
	$personPanelList.value?.scrollTo({
		top: 0
	});
}

const onScroll = () => {
	const el = $personPanelList.value
	if (!el) return

	isScrollBtnVisible.value = el.scrollTop > 300
	if (
		!clientStore.clientContactsLoading
		&& !clientStore.clientContactsPartialLoading
		&& clientStore.canLoadNextContacts
		&& el.scrollTop + el.offsetHeight > el.scrollHeight - 1000
	) {
		emit('on-get-partial')
	}
}

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const partialLoaderStyle = computed(() => ({
	position: 'relative',
	height: '32px',
	'background-color': 'transparent'
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "person-panel-list",
    ref_key: "$personPanelList",
    ref: $personPanelList
  }, [
    (isLoadingAll.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createTextVNode(" Найдено контактов: ")),
      _createElementVNode("div", _hoisted_2, _toDisplayString(clients.value?.Count || 0), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value?.Groups, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "person-panel-list__group",
        key: group.Id
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(group.Name) + ": ", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Persons, (contact) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: contact.Id
          }, [
            _createVNode(ClientsPanelListItem, {
              client: contact,
              "search-text": props.searchText
            }, null, 8, ["client", "search-text"]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "person-panel-list__divider" }, null, -1))
          ], 64))
        }), 128))
      ]))
    }), 128)),
    (!isLoadingAll.value && isLoadingPartial.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AppLoader, {
            style: _normalizeStyle(partialLoaderStyle.value)
          }, null, 8, ["style"])
        ]))
      : (!isLoadingAll.value && !canLoadNext.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Все контакты загружены "))
        : _createCommentVNode("", true),
    (isScrollBtnVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "person-panel-list__scroll-top",
          onClick: scrollListTop
        }, [
          _createVNode(AppIcon, {
            class: "client-item__footer-options-btn",
            name: "arrow-up",
            width: "24px",
            color: "#fff",
            title: "Наверх"
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})